export default "__VITE_ASSET__n56SM8Fd__"